"use client";

import React from "react";
import { Facebook, Instagram, Twitter, ArrowUp, Mail, Youtube } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-primary-foreground/10 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/BooksPage" className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">Books</Link>
        </li>
        <li data-index={2}>
          <Link to="/TheAuthorPage" className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">About</Link>
        </li>
        <li data-index={3}>
          <Link to="/ContactPage" className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  return <FormProvider>
      <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
        <input type="email" placeholder="Your email address" className="w-full bg-primary-foreground/5 border border-primary-foreground/20 rounded-md px-4 py-2.5 text-sm text-primary-foreground placeholder:text-primary-foreground/50 focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-all" required />
        <Button type="submit" className="w-full bg-accent text-accent-foreground hover:bg-accent/90 font-medium">
          Subscribe
        </Button>
      </form>
    </FormProvider>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-primary-foreground" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed mb-6">Faith-based books, Bible studies, and discipleship resources designed to help you grow in Christ and leave a lasting Godly legacy.</p>
            <div className="flex items-center gap-2 text-sm text-primary-foreground/80">
              <Mail className="size-4 text-accent" />
              <Link to="mailto:info@dustinroyerbooks.com" className="hover:text-accent transition-colors">dustin@royerheritage.com</Link>
            </div>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            
            <p className="text-primary-foreground/80 text-sm mb-6">Stay connected with Rooted Disciples for biblical teaching, encouragement, and resources to help you live rooted in purpose.</p>
            <div className="flex gap-4">
              <Link to="https://www.facebook.com/DustinRoyerBooks" className="p-2 rounded-lg border border-primary-foreground/20 text-primary-foreground/80 hover:text-accent hover:border-accent transition-all" aria-label="Facebook">
                <Facebook className="size-5" strokeWidth={1.5} />
              </Link>
              
              
              <Link to="https://www.youtube.com/@RootedDisciples" className="p-2 rounded-lg border border-primary-foreground/20 text-primary-foreground/80 hover:text-accent hover:border-accent transition-all" aria-label="Youtube">
                <Youtube className="size-5" strokeWidth={1.5} />
              </Link>
            </div>
          </div>

          {}
          
        </div>

        {}
        <Separator className="bg-primary-foreground/10 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-foreground/60 text-sm">
            &copy; {currentYear} Dustin Royer Books. All rights reserved.
          </p>
          
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-primary-foreground/60 hover:text-accent hover:bg-transparent gap-2">
            Back to Top
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </section>;
}